export const baseUrl = "https://my.mollie.com/oauth2/authorize";

const supportedLocales = [
  "en_US",
  "nl_NL",
  "nl_BE",
  "fr_FR",
  "fr_BE",
  "de_DE",
  "es_ES",
  "it_IT"
];

function getAppLocale() {
  const browserLocale = navigator.language || "en-US";
  const normalizedLocale = browserLocale.replace("-", "_");

  return supportedLocales.includes(normalizedLocale)
    ? normalizedLocale
    : "en_US";
}

export const molliePosApp = {
  id: 43,
  name: "mollie-pos",
  label: "Mollie POS",
  showTestConnection: true,
  useOAuth: true,
  skipSalesChannelCreation: true,
  logo: process.env.BASE_URL + "media/shopLogos/mollie.png",
  areaBlacklist: ["productSelection", "migration"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_MOLLIE_PRESET_ID,
    oauth: {
      client_id: process?.env?.VUE_APP_MOLLIE_APP_CLIENT_ID,
      redirect_uri: process?.env?.VUE_APP_MOLLIE_APP_REDIRECT_URL,
      scope:
        "payments.read payments.write profiles.read profiles.write orders.read orders.write payment-links.read payment-links.write terminals.read terminals.write",
      approval_prompt: "auto",
      response_type: "code",
      landing_page: "login",
      locale: getAppLocale()
    }
  }
};
